import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import {Checklist, ChecklistProperty, SaveChecklist} from '../api/dtos/dtos';

import {ApplicationContextConsumer, bindLoadingHandler, LoadingOverlayHandler} from '../app/ApplicationContext';
import HiddenFormItem from '../common/form-items/HiddenFormItem';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';
import {checklistPropertyNameMap, returnalExtraPropertyNameMap} from "./send/ChecklistTypes";
import {ChecklistFormMode} from "./dtos";
import ChecklistFormContent from "./ChecklistFormContent";

interface ChecklistFormProps extends FormComponentProps {
  mode: ChecklistFormMode,
  editable: boolean;
  checklistId?: number;
  rentalId?: number;
  returnalId?: number;
  rentalItemId?: number;
  rentalChecklist?: Checklist;
  returnalChecklist?: Checklist;
  onFormSubmit?: (checklist: SaveChecklist) => void;
  onFormCancel?: () => void;
}

const FIELD_ITEM_ID = 'itemId';
const FIELD_COMMENT = 'comment';

class ChecklistForm extends React.Component<ChecklistFormProps, {}> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public render() {
    const {form, rentalChecklist, returnalChecklist, editable, mode,} = this.props;

    const disabled = !editable;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Form style={{margin: '0 auto', maxWidth: 916}}>
          <HiddenFormItem
            form={form}
            fieldId={FIELD_ITEM_ID}
            initialValue={returnalChecklist ? returnalChecklist.id : rentalChecklist?.id}
            required={false}
          />

          <ChecklistFormContent
            rentalChecklist={rentalChecklist}
            returnalChecklist={returnalChecklist}
            editable={editable}
            mode={mode}
            form={form}
          />

          {(mode !== ChecklistFormMode.VIEW_RENTAL && mode !== ChecklistFormMode.VIEW_RETURNAL) &&
              <SubmitCancelFormItem
                  onSubmit={this.onFormSubmit}
                  onCancel={this.onFormCancel}
                  disabled={disabled}
              />
          }
        </Form>
      </>
    );
  }


  private onFormCancel = () => {
    this.props.onFormCancel?.();
  }

  private onFormSubmit = () => {
    const {
      form,
      checklistId,
      rentalChecklist,
      returnalChecklist,
      returnalId,
      rentalItemId,
      rentalId,
      onFormSubmit,
      mode
    } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const ps: ChecklistProperty[] = [];
        if (mode === ChecklistFormMode.CREATE_RETURNAL || mode === ChecklistFormMode.EDIT_RETURNAL) {
          checklistPropertyNameMap.forEach((name, key) => {
            const propertyValue = values[`${key}-returnal`]
            const comment = values[`${key}-returnal-comment`];
            ps.push({
              name: key,
              value: propertyValue ?? '-',
              comment,
            });
          });

          returnalExtraPropertyNameMap.forEach((name, key) => {
            const propertyValue = values[`${key}-returnal`]
            const comment = values[`${key}-returnal-comment`];
            ps.push({
              name: key,
              value: propertyValue,
              comment,
            });
          });
        } else {
          checklistPropertyNameMap.forEach((name, key) => {
            const propertyValue = values[`${key}-rental`]
            const comment = values[`${key}-rental-comment`];
            ps.push({
              name: key,
              value: propertyValue,
              comment,
            });
          });
        }

        const saveChecklistDto: SaveChecklist = {
          id: checklistId ? checklistId : null,
          rentalItemId: returnalChecklist?.rentalItem.id ?? rentalChecklist?.rentalItem.id ?? rentalItemId!,
          rentalId: rentalId ?? undefined,
          returnalId: returnalId ?? undefined,
          properties: ps,
          comment: values[FIELD_COMMENT],
          ignored: false
        };
        onFormSubmit?.(saveChecklistDto);
      }
    });
  };
}

export default Form.create<ChecklistFormProps>()(ChecklistForm);




// WEBPACK FOOTER //
// ./src/checklist/ChecklistForm.tsx